<template>
	<div id="breadcrumb" class="acea-row row-middle">
		<div class="widthBox">
			<router-link to="/">首页</router-link>
			<span v-if="oneNav">></span>
			<router-link v-if="oneNav" :to="oneNav.url">{{oneNav.name}}</router-link>
			<span>></span>
			<a>{{twoNav.name}}</a>
		</div>
	</div>
</template>
<script>
	export default {
		data:function() {
			return {
				oneNav:'',
				twoNav:'',
				urlS:[
					{
						name:'公司业务',
						url:'/corporate',
						detail:[
							{
								name:'业务生态',
								url:'/business',
							},
							{
								name:'主营产品',
								url:'/product',
							},
							{
								name:'品牌优势',
								url:'/brand',
							}
						]
					},
					{
						name:'新闻资讯',
						url:'/news',
						detail:[
							{
								name:'行业动态',
								url:'/dynamic',
							},
							{
								name:'科普知识',
								url:'/knowledge',
							},
							{
								name:'企业新闻',
								url:'/other',
							}
						]
					},
					{
						name:'关于我们',
						url:'/about',
						detail:[
							{
								name:'关于我们',
								url:'/company',
							},
							{
								name:'企业优势',
								url:'/advantage',
							}
						]
					}
				]
			};
		},
		created() {
			console.log(this.$router.history.current)
			this.urlS.map((item)=>{
				item.detail.map((ii)=>{
					if(ii.url == this.$router.history.current.path){
						this.oneNav = item
						this.twoNav = ii
					}
				})
			})
			console.log(this.twoNav)
		}
	}
</script>

<style lang="scss">
	#breadcrumb{
		background:#FCFDFE;
		border-bottom:1px solid #EFEFF0;
		height:64px;
		a{
			font-size:16px;
			color:#B5B4B4;
		}
		span{
			font-size:16px;
			color:#B5B4B4;
			font-family:'黑体';
			margin:0 8px;
		}
	}
	@media screen and(max-width:768px) {
		#breadcrumb{
			height:40px;
			a{
				font-size:14px;
			}
			span{
				font-size:14px;
			}
		}
	}
</style>
